<script>
  import { onMount } from 'svelte';
  import { InputStore } from '../../store';
  export let Input;

  InputStore.subscribe(() => {})

  let InputComponent = Input.component;

  let inputTag;
  onMount(() => {
    if (InputComponent.component.input) { inputTag.type = InputComponent.type; }
  })

</script>

{#if InputComponent.component.textarea}
  <textarea
  rows={InputComponent.height}
  placeholder={InputComponent.placeholder}
  bind:value={$InputStore[Input.id]}
  />
{:else}
  <input 
  placeholder={InputComponent.placeholder}
  bind:value={$InputStore[Input.id]}
  bind:this = {inputTag}
  />
{/if}



<style>
  input, textarea {
    border: 1px solid black;
    border-radius: 0;

    box-shadow: 1px 2px 3px rgba(0,0,0, 0.1);

  }

  textarea {
    resize: vertical;
    min-height: 2em;

  }
</style>